import { useState, createContext, useEffect } from 'react';

// Services
import walletServices from '/services/wallet';

export const WalletContext = createContext({
	error: null,
	data: null,
	transactions: null,
	refundsAvailable: false,
	updateAll: () => {
		console.error('Wallet Context not set up.');
	},
	getData: () => {
		console.error('Wallet Context not set up.');
	},
	getTransactions: () => {
		console.error('Wallet Context not set up.');
	},
});

export const WalletProvider = ({ children }) => {
	const [error, setError] = useState(null);
	const [data, setData] = useState(null);
	const [transactions, setTransactions] = useState(null);
	const [refundsAvailable, setRefundsAvailable] = useState(false);

	const getData = () => {
		return new Promise((resolve, reject) => {
			setData(null);
			walletServices
				.getData()
				.then((payload) => {
					setData(payload);
					resolve(payload);
				})
				.catch((error) => {
					setError(error);
					reject(error);
				});
		});
	};

	const getTransactions = () => {
		return new Promise((resolve, reject) => {
			setTransactions(null);
			walletServices
				.getTransactions()
				.then((payload) => {
					setTransactions(payload);
					resolve(payload);
				})
				.catch((error) => {
					setError(error);
					reject(error);
				});
		});
	};

	const updateAll = () => {
		return Promise.all([getData(), getTransactions()]);
	};

	useEffect(() => {
		walletServices.getRefundAvailability().then(availability => {
			setRefundsAvailable(!!availability);
		}).catch(error => {
			console.error('Refunds config error:', error);
		});
	}, [])

	return (
		<WalletContext.Provider
			value={{
				error,
				data,
				transactions,
				refundsAvailable,
				updateAll,
				getData,
				getTransactions,
			}}
		>
			{children}
		</WalletContext.Provider>
	);
};
